<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    :title="`ポリシー${isEdit ? '編集' : '追加'}`"
    :sub-title="`インターネットFW ${$filter.enumTo(
      zone.srcZoneType,
      'zoneType'
    )}/${zone.srcZoneName} → ${$filter.enumTo(zone.dstZoneType, 'zoneType')}/${
      zone.dstZoneName
    }`"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <cross-validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- ID -->
                <v-row>
                  <v-col>
                    <template v-if="isEdit">
                      <app-label-group
                        label="ID"
                        :value="form.policyId"
                      ></app-label-group>
                    </template>
                    <template v-else>
                      <validation-provider
                        name="policyId"
                        v-model="form.policyId"
                        label="ID"
                        :rules="{
                          required: true,
                          numeric: true,
                          is_not_zero_padding: true,
                          between: { min: 1001, max: 9999 },
                          duplicate: { list: existsPolicyIds },
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-badge
                          item="ID"
                          :msg="$filter.message('info_policy_id')"
                          placement="end"
                        />
                        <app-form-input
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                        />
                      </validation-provider>
                    </template>
                  </v-col>
                </v-row>
                <!-- 送信元 -->
                <v-row>
                  <v-col>
                    <v-sheet border class="pa-4" rounded="sm">
                      <template v-if="!isInternetToAccess">
                        <validation-provider
                          name="srcAddressList"
                          v-model="form.srcAddress.srcAddressList"
                          label="送信元アドレス"
                          :rules="{
                            required: true,
                          }"
                          v-slot="{ componentField, errorMessage }"
                        >
                          <app-badge
                            item="送信元アドレス"
                            :isInfo="false"
                            placement="end"
                            :isRequired="true"
                          ></app-badge>
                          <app-multi-select
                            v-bind="componentField"
                            :options="srcAddresses"
                            :multiple="true"
                            :custom-label="addressLabel"
                            track-by="ipAddressId"
                            :sort-orders="[
                              ['ipAddressName', 'asc'],
                              ['ipAddress', 'asc'],
                            ]"
                            group-label="label"
                            group-values="values"
                            :closeOnSelect="false"
                            :group-select="true"
                            selectGroupLabel="全てを選択します"
                            deselectGroupLabel="全ての選択を取り消します"
                            :error-messages="errorMessage"
                          >
                            <template #tag="{ option, remove }">
                              <multi-select-tag
                                :option="option"
                                :remove="remove"
                              >
                                <div class="multiselect-tbody">
                                  <p class="v-col-3 pa-0">
                                    {{ option.ipAddress }}
                                  </p>
                                  <p class="v-col-9 pa-0">
                                    {{
                                      $filter.emptyTo(option.ipAddressName, "-")
                                    }}
                                  </p>
                                </div>
                              </multi-select-tag>
                            </template>

                            <template #option="{ option }">
                              <template v-if="option.$isLabel">{{
                                option.$groupLabel
                              }}</template>
                              <div v-else class="multiselect-tbody">
                                <p class="v-col-3 pa-0">
                                  {{ option.ipAddress }}
                                </p>
                                <p class="v-col-8 pa-0">
                                  {{
                                    $filter.emptyTo(option.ipAddressName, "-")
                                  }}
                                </p>
                              </div>
                            </template>
                          </app-multi-select>
                        </validation-provider>
                      </template>
                      <template v-else>
                        <app-badge
                          item="送信元アドレス"
                          msg="アドレスを選択する場合は、１つ以上指定してください。"
                          placement="end"
                          :isRequired="radioSrcAddress === 'SELECT'"
                        ></app-badge>
                        <v-radio-group
                          v-model="radioSrcAddress"
                          hide-details
                          density="compact"
                        >
                          <v-radio value="ANY" label="any" />
                          <v-radio value="SELECT" label="アドレス" />
                        </v-radio-group>
                        <template v-if="radioSrcAddress === 'SELECT'">
                          <!-- 送信元アドレス選択 -->
                          <app-label-group label="アドレス" class="mt-2">
                            <template #value>
                              <div class="mt-2">
                                <app-multi-select
                                  v-model="form.srcAddress.srcAddressList"
                                  :options="srcAddresses"
                                  :multiple="true"
                                  :custom-label="addressLabel"
                                  track-by="ipAddressId"
                                  :sort-orders="[
                                    ['ipAddressName', 'asc'],
                                    ['ipAddress', 'asc'],
                                  ]"
                                  group-label="label"
                                  group-values="values"
                                  :closeOnSelect="false"
                                  :group-select="true"
                                  selectGroupLabel="全てを選択します"
                                  deselectGroupLabel="全ての選択を取り消します"
                                  hide-details
                                >
                                  <template #tag="{ option, remove }">
                                    <multi-select-tag
                                      :option="option"
                                      :remove="remove"
                                    >
                                      <div class="multiselect-tbody">
                                        <p class="v-col-3 pa-0">
                                          {{ option.ipAddress }}
                                        </p>
                                        <p class="v-col-9 pa-0">
                                          {{
                                            $filter.emptyTo(
                                              option.ipAddressName,
                                              "-"
                                            )
                                          }}
                                        </p>
                                      </div>
                                    </multi-select-tag>
                                  </template>

                                  <template #option="{ option }">
                                    <template v-if="option.$isLabel">{{
                                      option.$groupLabel
                                    }}</template>
                                    <div v-else class="multiselect-tbody">
                                      <p class="v-col-3 pa-0">
                                        {{ option.ipAddress }}
                                      </p>
                                      <p class="v-col-8 pa-0">
                                        {{
                                          $filter.emptyTo(
                                            option.ipAddressName,
                                            "-"
                                          )
                                        }}
                                      </p>
                                    </div>
                                  </template>
                                </app-multi-select>
                              </div>
                            </template>
                          </app-label-group>
                          <!-- FQDN選択 -->
                          <app-label-group label="FQDN" class="mt-2">
                            <template #value>
                              <div class="mt-2">
                                <app-multi-select
                                  v-if="'srcFqdnList' in form.srcAddress"
                                  v-model="form.srcAddress.srcFqdnList"
                                  :options="fqdnOptions"
                                  :multiple="true"
                                  :custom-label="fqdnLabel"
                                  track-by="fqdnId"
                                  :sort-orders="[[fqdnSort, 'asc']]"
                                  group-label="label"
                                  group-values="values"
                                  :closeOnSelect="false"
                                  :group-select="true"
                                  selectGroupLabel="全てを選択します"
                                  deselectGroupLabel="全ての選択を取り消します"
                                  hide-details
                                >
                                  <template #tag="{ option, remove }">
                                    <multi-select-tag
                                      :option="option"
                                      :remove="remove"
                                    >
                                      <div class="multiselect-tbody">
                                        <p class="v-col-12 pa-0">
                                          {{ option.fqdnName ?? option.fqdn }}
                                        </p>
                                      </div>
                                    </multi-select-tag>
                                  </template>
                                  <template #option="{ option }">
                                    <template v-if="option.$isLabel">{{
                                      option.$groupLabel
                                    }}</template>
                                    <div v-else class="multiselect-tbody">
                                      <p class="v-col-12 pa-0">
                                        {{ option.fqdnName ?? option.fqdn }}
                                      </p>
                                    </div>
                                  </template>
                                </app-multi-select>
                              </div>
                            </template>
                          </app-label-group>
                          <!-- 国と地域選択 -->
                          <app-label-group label="国と地域" class="mt-2">
                            <template #value>
                              <div class="mt-2">
                                <app-multi-select
                                  v-if="'srcCountryList' in form.srcAddress"
                                  v-model="form.srcAddress.srcCountryList"
                                  :options="countryOptions"
                                  :multiple="true"
                                  label="country"
                                  track-by="countrySeq"
                                  :sort-orders="[['country', 'asc']]"
                                  group-label="label"
                                  group-values="values"
                                  :closeOnSelect="false"
                                  :group-select="true"
                                  selectGroupLabel="全てを選択します"
                                  deselectGroupLabel="全ての選択を取り消します"
                                  hide-details
                                />
                              </div>
                            </template>
                          </app-label-group>
                        </template>
                        <cross-validation-provider
                          class="mt-2"
                          :passed="validSrcAddressRequired"
                          vid="srcAddressRequired"
                        >
                          {{ $filter.message("required_some") }}
                        </cross-validation-provider>
                      </template>
                    </v-sheet>
                  </v-col>
                </v-row>
                <!-- 宛先 -->
                <v-row>
                  <v-col>
                    <v-sheet border class="pa-4" rounded="sm">
                      <template v-if="isInternetToAccess">
                        <validation-provider
                          name="dstAddressList"
                          v-model="form.dstAddress.dstAddressList"
                          label="宛先アドレス"
                          :rules="{ required: true }"
                          v-slot="{ componentField, errorMessage }"
                        >
                          <app-badge
                            item="宛先アドレス"
                            :isInfo="false"
                            placement="end"
                            :isRequired="true"
                          />
                          <app-multi-select
                            v-bind="componentField"
                            :options="dstAddresses"
                            :multiple="true"
                            :custom-label="addressLabel"
                            track-by="ipAddressId"
                            :sort-orders="[
                              ['ipAddressName', 'asc'],
                              ['ipAddress', 'asc'],
                            ]"
                            group-label="label"
                            group-values="values"
                            :closeOnSelect="false"
                            :group-select="true"
                            selectGroupLabel="全てを選択します"
                            deselectGroupLabel="全ての選択を取り消します"
                            :error-messages="errorMessage"
                          >
                            <template #tag="{ option, remove }">
                              <multi-select-tag
                                :option="option"
                                :remove="remove"
                              >
                                <div class="multiselect-tbody">
                                  <p class="v-col-3 pa-0">
                                    {{ option.ipAddress }}
                                  </p>
                                  <p class="v-col-9 pa-0">
                                    {{
                                      $filter.emptyTo(option.ipAddressName, "-")
                                    }}
                                  </p>
                                </div>
                              </multi-select-tag>
                            </template>

                            <template #option="{ option }">
                              <template v-if="option.$isLabel">{{
                                option.$groupLabel
                              }}</template>
                              <div v-else class="multiselect-tbody">
                                <p class="v-col-3 pa-1">
                                  {{ option.ipAddress }}
                                </p>
                                <p class="v-col-8 pa-0">
                                  {{
                                    $filter.emptyTo(option.ipAddressName, "-")
                                  }}
                                </p>
                              </div>
                            </template>
                          </app-multi-select>
                        </validation-provider>
                      </template>
                      <template v-else>
                        <app-badge
                          item="宛先アドレス"
                          msg="アドレスを選択する場合は、１つ以上指定してください。"
                          placement="end"
                          :isRequired="radioDstAddress === 'SELECT'"
                        ></app-badge>
                        <v-radio-group
                          v-model="radioDstAddress"
                          density="compact"
                          hide-details
                        >
                          <v-radio value="ANY" label="any"></v-radio>
                          <v-radio value="SELECT" label="アドレス"></v-radio>
                        </v-radio-group>
                        <template v-if="radioDstAddress === 'SELECT'">
                          <!-- 宛先アドレス選択 -->
                          <app-label-group label="アドレス" class="mt-2">
                            <template #value>
                              <div class="mt-2">
                                <app-multi-select
                                  v-model="form.dstAddress.dstAddressList"
                                  :options="dstAddresses"
                                  :multiple="true"
                                  :custom-label="addressLabel"
                                  track-by="ipAddressId"
                                  :sort-orders="[
                                    ['ipAddressName', 'asc'],
                                    ['ipAddress', 'asc'],
                                  ]"
                                  group-label="label"
                                  group-values="values"
                                  :closeOnSelect="false"
                                  :group-select="true"
                                  selectGroupLabel="全てを選択します"
                                  deselectGroupLabel="全ての選択を取り消します"
                                  hide-details
                                >
                                  <template #tag="{ option, remove }">
                                    <multi-select-tag
                                      :option="option"
                                      :remove="remove"
                                    >
                                      <div class="multiselect-tbody">
                                        <p class="v-col-3 pa-0">
                                          {{ option.ipAddress }}
                                        </p>
                                        <p class="v-col-9 pa-0">
                                          {{
                                            $filter.emptyTo(
                                              option.ipAddressName,
                                              "-"
                                            )
                                          }}
                                        </p>
                                      </div>
                                    </multi-select-tag>
                                  </template>

                                  <template #option="{ option }">
                                    <template v-if="option.$isLabel">{{
                                      option.$groupLabel
                                    }}</template>
                                    <div v-else class="multiselect-tbody">
                                      <p class="v-col-3 pa-1">
                                        {{ option.ipAddress }}
                                      </p>
                                      <p class="v-col-8 pa-0">
                                        {{
                                          $filter.emptyTo(
                                            option.ipAddressName,
                                            "-"
                                          )
                                        }}
                                      </p>
                                    </div>
                                  </template>
                                </app-multi-select>
                              </div>
                            </template>
                          </app-label-group>
                          <!-- FQDN選択 -->
                          <app-label-group label="FQDN" class="mt-2">
                            <template #value>
                              <div class="mt-2">
                                <app-multi-select
                                  v-if="'dstFqdnList' in form.dstAddress"
                                  v-model="form.dstAddress.dstFqdnList"
                                  :options="fqdnOptions"
                                  :multiple="true"
                                  :custom-label="fqdnLabel"
                                  track-by="fqdnId"
                                  :sort-orders="[[fqdnSort, 'asc']]"
                                  group-label="label"
                                  group-values="values"
                                  :closeOnSelect="false"
                                  :group-select="true"
                                  selectGroupLabel="全てを選択します"
                                  deselectGroupLabel="全ての選択を取り消します"
                                  hide-details
                                >
                                  <template #tag="{ option, remove }">
                                    <multi-select-tag
                                      :option="option"
                                      :remove="remove"
                                    >
                                      <div class="multiselect-tbody">
                                        <p class="v-col-12 pa-0">
                                          {{ option.fqdnName ?? option.fqdn }}
                                        </p>
                                      </div>
                                    </multi-select-tag>
                                  </template>
                                  <template #option="{ option }">
                                    <template v-if="option.$isLabel">{{
                                      option.$groupLabel
                                    }}</template>
                                    <div v-else class="multiselect-tbody">
                                      <p class="v-col-12 pa-0">
                                        {{ option.fqdnName ?? option.fqdn }}
                                      </p>
                                    </div>
                                  </template>
                                </app-multi-select>
                              </div>
                            </template>
                          </app-label-group>
                          <!-- 国と地域選択 -->
                          <app-label-group label="国と地域" class="mt-2">
                            <template #value>
                              <div class="mt-2">
                                <app-multi-select
                                  v-if="'dstCountryList' in form.dstAddress"
                                  v-model="form.dstAddress.dstCountryList"
                                  :options="countryOptions"
                                  :multiple="true"
                                  label="country"
                                  track-by="countrySeq"
                                  :sort-orders="[['country', 'asc']]"
                                  group-label="label"
                                  group-values="values"
                                  :closeOnSelect="false"
                                  :group-select="true"
                                  selectGroupLabel="全てを選択します"
                                  deselectGroupLabel="全ての選択を取り消します"
                                  hide-details
                                />
                              </div>
                            </template>
                          </app-label-group>
                        </template>
                        <cross-validation-provider
                          class="mt-2"
                          :passed="validDstAddressRequired"
                          vid="dstAddressRequired"
                        >
                          {{ $filter.message("required_some") }}
                        </cross-validation-provider>
                      </template>
                    </v-sheet>
                  </v-col>
                </v-row>
                <!-- サービス -->
                <v-row>
                  <v-col>
                    <v-sheet border class="pa-4" rounded="sm">
                      <app-badge
                        item="サービス"
                        msg="サービスを選択する場合は、１つ以上指定してください。"
                        placement="end"
                        :isRequired="form.serviceOption === 'SELECT'"
                      />
                      <v-radio-group
                        v-model="form.serviceOption"
                        density="compact"
                      >
                        <v-radio value="ANY" label="any" />
                        <v-radio
                          value="DEFAULT"
                          label="Application-default"
                          :disabled="isDisabledServiceAppDefault"
                        />
                        <v-radio value="SELECT" label="Select" />
                      </v-radio-group>
                      <template v-if="form.serviceOption === 'SELECT'">
                        <validation-provider
                          name="serviceList"
                          label="定義済みサービスおよび個別サービス一覧"
                          v-model="form.serviceList"
                          :rules="{ required: true }"
                          v-slot="{ componentField, errorMessage }"
                        >
                          <app-badge
                            item="定義済みサービスおよび個別サービス一覧"
                            :is-info="false"
                            :isRequired="false"
                          ></app-badge>
                          <app-multi-select
                            v-bind="componentField"
                            :options="serviceOptions"
                            :multiple="true"
                            :sort-orders="[
                              ['_sortKey', 'asc'],
                              ['serviceName', 'asc'],
                            ]"
                            group-label="label"
                            group-values="values"
                            :custom-label="serviceNameLabel"
                            track-by="_id"
                            :closeOnSelect="false"
                            :group-select="true"
                            selectGroupLabel="グループ全てを選択します"
                            deselectGroupLabel="グループ全ての選択を取り消します"
                            :error-messages="errorMessage"
                          >
                            <template #tag="{ option, remove }">
                              <multi-select-tag
                                :option="option"
                                :remove="remove"
                              >
                                <div class="multiselect-tbody">
                                  <p class="v-col-5 pa-0">
                                    {{ option.serviceName }}
                                  </p>
                                  <p class="v-col-1 pa-0">
                                    {{ option.protocol }}
                                  </p>
                                  <p>{{ option.portNumber }}</p>
                                </div>
                              </multi-select-tag>
                            </template>

                            <template #option="{ option }">
                              <template v-if="option.$isLabel">
                                {{ option.$groupLabel }}
                              </template>
                              <div class="multiselect-tbody">
                                <p class="v-col-5 pa-0">
                                  {{ option.serviceName }}
                                </p>
                                <p class="v-col-1 pa-0">
                                  {{ option.protocol }}
                                </p>
                                <p class="v-col-5 pa-0">
                                  {{ option.portNumber }}
                                </p>
                              </div>
                            </template>
                          </app-multi-select>
                        </validation-provider>
                      </template>
                    </v-sheet>
                  </v-col>
                </v-row>
                <!-- プロファイル -->
                <v-row>
                  <v-col>
                    <v-sheet border class="pa-4" rounded="sm">
                      <app-badge
                        item="プロファイル"
                        msg="ユーザー定義プロファイルを選択する場合は、１つ以上指定してください。"
                        :isRequired="form.profile.internetFW === 'USER'"
                      />
                      <div class="pa-4">
                        <v-row>
                          <v-col cols="4" class="pt-2">
                            <app-badge
                              item="インターネットFW"
                              :msg="$filter.message('info_internet_fw')"
                              :isRequired="false"
                            ></app-badge>
                          </v-col>
                          <v-col>
                            <v-radio-group
                              inline
                              density="comfortable"
                              v-model="form.profile.internetFW"
                              hide-details
                            >
                              <v-radio value="OFF" label="OFF" />
                              <v-radio value="ANY" label="any" />
                              <v-radio
                                value="USER"
                                label="ユーザー定義プロファイル"
                              />
                            </v-radio-group>
                            <validation-provider
                              v-if="form.profile.internetFW === 'USER'"
                              name="profileInternetFw"
                              v-model="form.profile.profileInternetFw"
                              label="ユーザー定義プロファイル"
                              :rules="{ required: true }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-select
                                return-object
                                class="mt-2"
                                :items="excludeAnyInternetFWProfiles"
                                item-value="profileInternetFwSeq"
                                item-title="profileInternetFwName"
                                v-bind="componentField"
                                :error-messages="errorMessage"
                                :field-meta="meta"
                              ></app-select>
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </div>
                    </v-sheet>
                  </v-col>
                </v-row>
                <!-- アクション -->
                <v-row>
                  <v-col>
                    <v-sheet border class="pa-4" rounded="sm">
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="4" class="pt-2">
                              <app-badge
                                item="アクション"
                                :isInfo="false"
                                :isRequired="false"
                              ></app-badge>
                            </v-col>
                            <v-col>
                              <v-radio-group
                                density="comfortable"
                                v-model="form.actionType"
                                hide-details
                              >
                                <v-radio value="ALLOW" label="Allow" />
                                <v-radio value="DENY" label="Deny" />
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col>
                          <v-row>
                            <v-col cols="4" class="pt-2">
                              <app-badge
                                item="ログ出力"
                                :isRequired="false"
                                :isInfo="false"
                              />
                            </v-col>
                            <v-col>
                              <v-radio-group
                                v-model="form.isLogOutput"
                                density="comfortable"
                                hide-details
                              >
                                <v-radio :value="false" label="OFF" />
                                <v-radio
                                  :value="true"
                                  :disabled="isDisabledLogOutputON"
                                  label="ON"
                                />
                              </v-radio-group>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="4" class="pt-2">
                              <app-badge
                                item="有効/無効"
                                :isRequired="false"
                                :isInfo="false"
                              />
                            </v-col>
                            <v-col>
                              <v-radio-group
                                v-model="form.isPolicyStatus"
                                density="comfortable"
                                hide-details
                              >
                                <v-radio :value="true" label="有効" />
                                <v-radio :value="false" label="無効" />
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-col>
                </v-row>
                <!-- 備考 -->
                <v-row>
                  <v-col>
                    <v-sheet border class="pa-4" rounded="sm">
                      <validation-provider
                        name="description"
                        v-model="form.description"
                        label="備考"
                        :rules="{ max: { length: 20 } }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-badge
                          item="備考"
                          msg="20文字以内"
                          :isRequired="false"
                        />
                        <app-form-input
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                        />
                      </validation-provider>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn variant="flat" type="submit" color="primary">保存</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type {
  CommonProfile,
  Country,
  GetDstAddress2,
  GetPolicy,
  GetPolicyType1,
  GetSrcAddress1,
} from "@/apis/NwPolicyApi";
import type { InternetfwProfileList } from "@/apis/ProfileApi";
import cloneDeep from "lodash/cloneDeep";
import { mapState } from "vuex";
import type { DefalutService } from "@/apis/ServiceApi";
import type { CustomServiceList } from "@/apis/CustomServiceApi";
import type { ZoneRelationItem } from "@/apis/ZoneRelationApi";
import type {
  Type1ExtraInfo,
  Type1InternetAddress,
  Type1InternetFQDN,
  Type1PrivateInfo,
  Type1PrivateLine,
  Type1PrivateSite,
  Type1Site,
} from "@/apis/Type1SiteApi";
import MultiSelectTag from "@/components/MultiSelectTag.vue";
import type { Type1IFWPolicy } from "@/modals/applianceContractSetting/type1/policy/InternetType1PolicyIfwList.vue";
import InternetType1PolicyRuleIfwConfirm from "@/modals/applianceContractSetting/type1/policy/ifw/InternetType1PolicyRuleIfwConfirm.vue";
import { VueFinalModal } from "vue-final-modal";

// デフォルト/カスタムを識別するためのIDを付与した型
type EditDefaultService = Type1IFWPolicy["defaultServiceList"][0] & {
  _id: string;
};
type EditCustomService = Type1IFWPolicy["customServiceList"][0] & {
  _id: string;
};

type EditType1IFWPolicy = Omit<
  Type1IFWPolicy,
  "defaultServiceList" | "customServiceList"
> & {
  /** デフォルトサービスリスト & カスタムサービスリスト */
  serviceList: (EditDefaultService | EditCustomService)[];
};

export default defineComponent({
  name: "InternetType1PolicyRuleIfwEdit",
  components: { MultiSelectTag },
  props: {
    /** ゾーン */
    zone: {
      type: Object as PropType<ZoneRelationItem>,
      required: true,
    },
    /** 変更対象ポリシー. 新規作成の場合は不要 */
    policy: {
      type: Object as PropType<Type1IFWPolicy>,
      default: undefined,
    },
    /** type1ポリシー全体 */
    type1Policy: {
      type: Object as PropType<GetPolicyType1>,
      required: true,
    },
  },
  data() {
    const clonePolicy = cloneDeep(this.policy);
    const form = (
      clonePolicy
        ? // 更新
          {
            ...clonePolicy,
            serviceList: [
              ...clonePolicy.customServiceList.map((e) => ({
                _id: `custom_${e.customServiceSeq}`,
                _sortKey: "custom",
                ...e,
              })),
              ...clonePolicy.defaultServiceList.map((e) => ({
                _id: `default_${e.serviceSeq}`,
                _sortKey: "default",
                ...e,
              })),
            ],
          }
        : // 新規
          {
            srcAddress: {
              srcAddressList: [],
              srcFqdnList: [],
              srcCountryList: [],
            },
            dstAddress: {
              dstAddressList: [],
              dstFqdnList: [],
              dstCountryList: [],
            },
            serviceOption: "ANY",
            serviceList: [],
            profile: {
              internetFW: "OFF",
            },
            actionType: "ALLOW",
            isLogOutput: false,
            isPolicyStatus: true,
            policyCategoryInfo: "CUSTOM_POLICY",
          }
    ) as EditType1IFWPolicy;

    const partialSrcAddress = form.srcAddress as Partial<GetSrcAddress1>;
    const partialDstAddress = form.dstAddress as Partial<GetDstAddress2>;

    return {
      form,
      // 送信元、宛先（any/アドレス）
      // 送信元：アクセス回線→インターネット時、SELECTで固定、以外の場合、初期値はform設定内容から判断（新規の場合はany）
      radioSrcAddress:
        this.zone.srcZoneType !== "INTERNET"
          ? "SELECT"
          : ((partialSrcAddress.srcAddressList!.length === 0 &&
            (partialSrcAddress.srcFqdnList?.length ?? 0) === 0 &&
            (partialSrcAddress.srcCountryList?.length ?? 0) === 0
              ? "ANY"
              : "SELECT") as "ANY" | "SELECT"),
      // 宛先：インターネット→アクセス回線時、SELECTで固定、以外の場合、初期値はform設定内容から判断（新規の場合はany）
      radioDstAddress:
        this.zone.srcZoneType === "INTERNET"
          ? "SELECT"
          : ((partialDstAddress.dstAddressList!.length === 0 &&
            (partialDstAddress.dstFqdnList?.length ?? 0) === 0 &&
            (partialDstAddress.dstCountryList?.length ?? 0) === 0
              ? "ANY"
              : "SELECT") as "ANY" | "SELECT"),
      // エクストラサイト（アドレス一覧）
      extraOrPrivateSiteAddresses: [] as
        | Type1ExtraInfo["siteList"][0]["addressList"]
        | Type1PrivateInfo["lineList"][0]["siteList"][0]["addressList"],
      // インターネット（アドレス、FQDN、国一覧）
      internetAddresses: [] as Type1InternetAddress[],
      internetFqdns: [] as Type1InternetFQDN[],
      internetCountries: [] as Country["countryList"],
      // デフォルトサービス,カスタムサービス
      defaultServices: [] as DefalutService["defaultServiceList"],
      customServices: [] as CustomServiceList["customServiceList"],
      // インターネットFWプロファイル、URLプロファイル
      internetFWProfiles: [] as InternetfwProfileList["profileList"],

      isLoaded: false,
    };
  },
  computed: {
    ...mapState("user", {
      contractSummary: "contractSummary",
    }),
    /** true: Internet発 */
    isInternetToAccess(): boolean {
      return this.zone.srcZoneType === "INTERNET";
    },
    /** true: 編集, false: 新規 */
    isEdit(): boolean {
      return !!this.policy;
    },
    /** 送信元アドレス選択肢。インターネット発の場合はインターネットサイト、アクセス拠点発の場合はエクストラサイトまたはプライベートサイト */
    srcAddresses(): {
      label: string;
      values: Type1InternetAddress[];
    }[] {
      if (this.isInternetToAccess) {
        return this.internetAddresses.length !== 0
          ? [
              {
                label: "全選択",
                values: this.internetAddresses,
              },
            ]
          : [];
      } else {
        return this.extraOrPrivateSiteAddresses.length !== 0
          ? [
              {
                label: "全選択",
                values: this.extraOrPrivateSiteAddresses,
              },
            ]
          : [];
      }
    },
    /** 宛先アドレス選択肢。インターネット発の場合はエクストラサイト、アクセス拠点発の場合はインターネットサイト */
    dstAddresses(): {
      label: string;
      values: Type1InternetAddress[];
    }[] {
      if (!this.isInternetToAccess) {
        return this.internetAddresses.length !== 0
          ? [
              {
                label: "全選択",
                values: this.internetAddresses,
              },
            ]
          : [];
      } else {
        return this.extraOrPrivateSiteAddresses.length !== 0
          ? [
              {
                label: "全選択",
                values: this.extraOrPrivateSiteAddresses,
              },
            ]
          : [];
      }
    },
    /** FQDNのSelectの選択肢 */
    fqdnOptions(): {
      label: string;
      values: Type1InternetFQDN[];
    }[] {
      return this.internetFqdns.length !== 0
        ? [
            {
              label: "全選択",
              values: this.internetFqdns,
            },
          ]
        : [];
    },
    /** 国と地域のSelectの選択肢 */
    countryOptions(): {
      label: string;
      values: Country["countryList"];
    }[] {
      return this.internetCountries.length !== 0
        ? [
            {
              label: "全選択",
              values: this.internetCountries,
            },
          ]
        : [];
    },
    /** デフォルトサービス/個別サービスSelectの選択肢 */
    serviceOptions(): {
      label: string;
      values: EditDefaultService[] | EditCustomService[];
    }[] {
      const options = [];
      // 個別サービス
      if (this.customServices.length !== 0) {
        options.push({
          label: "個別サービス（全選択）",
          values: this.customServices.map((e) => ({
            _id: `custom_${e.customServiceSeq}`,
            ...e,
          })),
        });
      }
      // デフォルトサービス
      if (this.defaultServices.length !== 0) {
        options.push({
          label: "定義済みサービス（全選択）",
          values: this.defaultServices.map((e) => ({
            _id: `default_${e.serviceSeq}`,
            ...e,
          })),
        });
      }

      return options;
    },
    /** anyを除外済みのインターネットFWプロファイル一覧 */
    excludeAnyInternetFWProfiles(): InternetfwProfileList["profileList"] {
      return this.internetFWProfiles.filter(
        (e) => e.profileInternetFwName !== "any"
      );
    },
    /** true: サービスオプションのApplication-Default選択不可, false: 選択可能 */
    isDisabledServiceAppDefault(): boolean {
      return this.form.profile.internetFW === "ANY";
    },
    /** true: ログ出力のON選択不可, false: 選択可能 */
    isDisabledLogOutputON(): boolean {
      return (
        this.form.actionType === "ALLOW" && !this.contractSummary.isAllowLog
      );
    },
    /** 既存のtype1ポリシーID一覧 */
    existsPolicyIds(): string[] {
      const p = this.type1Policy;
      return [
        ...(p.policyIfwType1?.accessPointToInternetList ?? []).flatMap(
          (v) => v.policyList
        ),
        ...(p.policyIfwType1?.internetToAccessPointList ?? []).flatMap(
          (v) => v.policyList
        ),
        ...(p.policyIPMasqueradeType1List ?? []).flatMap((v) => v.policyList),
        ...(p.policyNatType1List ?? []).flatMap((v) => v.policyList),
      ].map((e) => e.policyId);
    },
    /** true: 送信元アドレスOK（SELECTかつインタネット発の場合の場合にいずれかが選択されていること）, false: NG */
    validSrcAddressRequired(): boolean {
      if (this.radioSrcAddress !== "SELECT" || !this.isInternetToAccess) {
        return true;
      }
      const address = this.form.srcAddress as Partial<GetSrcAddress1>;
      return this.$crossValidation.requiredSome(
        address.srcAddressList,
        address.srcFqdnList,
        address.srcCountryList
      );
    },
    /** true: 宛先アドレスOK（SELECTかつアクセス拠点発の場合にいずれかが選択されていること）, false: NG */
    validDstAddressRequired(): boolean {
      if (this.radioDstAddress !== "SELECT" || this.isInternetToAccess) {
        return true;
      }
      const address = this.form.dstAddress as Partial<GetDstAddress2>;
      return this.$crossValidation.requiredSome(
        address.dstAddressList,
        address.dstFqdnList,
        address.dstCountryList
      );
    },
    internetZoneId(): string {
      if (this.zone.srcZoneType === "INTERNET") {
        return this.zone.srcZoneId;
      } else {
        return this.zone.dstZoneId;
      }
    },
    privateZoneId(): string | undefined {
      if (this.zone.srcZoneType === "PRIVATE") {
        return this.zone.srcZoneId;
      } else if (this.zone.dstZoneType === "PRIVATE") {
        return this.zone.dstZoneId;
      } else {
        return undefined;
      }
    },
    extraZoneId(): string | undefined {
      if (this.zone.srcZoneType === "EXTRA") {
        return this.zone.srcZoneId;
      } else if (this.zone.dstZoneType === "EXTRA") {
        return this.zone.dstZoneId;
      } else {
        return undefined;
      }
    },
  },
  watch: {
    /** any選択 + サービスオプションがdefaultの場合はサービスオプションをanyに変更 */
    "form.profile.internetFW"(newValue: CommonProfile["internetFW"]) {
      if (newValue === "ANY" && this.form.serviceOption === "DEFAULT") {
        this.form.serviceOption = "ANY";
      }
    },
    /** アクション変更時はログ出力をOFFにクリア */
    "form.actionType"() {
      this.form.isLogOutput = false;
    },
  },
  async mounted() {
    // 選択肢などの必要情報を取得
    // PrivateZoneの場合、PrivateSiteからアドレスを取得、以外の場合、ExtraSiteからアドレスを取得
    if (this.privateZoneId) {
      // IPアドレスで昇順ソートするために、プライベートサイト情報を一時保存
      this.extraOrPrivateSiteAddresses = (
        await this.$api.type1SiteZone.getType1PrivateList()
      ).lineList
        .flatMap((v: Type1PrivateLine) => v.siteList)
        .flatMap((v: Type1PrivateSite) => v.addressList)
        .filter((v: Type1InternetAddress) => v.zoneId === this.privateZoneId)
        .sortBy(["ipAddress", "asc"]);
    } else {
      // IPアドレスで昇順ソートするために、エクストラサイト情報を一時保存
      this.extraOrPrivateSiteAddresses = (
        await this.$api.type1SiteZone.getType1ExtraList()
      ).siteList
        .flatMap((v: Type1Site) => v.addressList)
        .filter((v: Type1InternetAddress) => v.zoneId === this.extraZoneId)
        .sortBy(["ipAddress", "asc"]);
    }
    const internetSite = await this.$api.type1SiteZone.getType1InternetList();
    // zoneIdが一致しているアドレスリストを表示
    this.internetAddresses = internetSite.addressList
      .filter((v: Type1InternetAddress) => v.zoneId === this.internetZoneId)
      .sortBy(["ipAddress", "asc"]);
    this.internetFqdns = internetSite.fqdnList
      .filter((v: Type1InternetFQDN) => v.zoneId === this.internetZoneId)
      .sortBy([(e: Type1InternetFQDN) => e.fqdnName ?? e.fqdn, "asc"]);
    this.internetCountries = (
      await this.$api.nwPolicy.getCountries()
    ).countryList.sortBy(["country", "asc"]);

    this.defaultServices = (
      await this.$api.serviceApi.getDefaultService()
    ).defaultServiceList.sortBy(["serviceName", "asc"]);
    this.customServices = (
      await this.$api.customServiceApi.getType1CustomService()
    ).customServiceList.sortBy(["serviceName", "asc"]);

    this.internetFWProfiles = (
      await this.$api.profileApi.getType1Profile()
    ).profileList.sortBy(["profileInternetFwName", "asc"]);

    this.isLoaded = true;
  },
  methods: {
    /** ルール編集の完了 */
    async submit() {
      const policy = {
        ...this.form,
        srcAddress: {
          ...(this.radioSrcAddress === "ANY"
            ? { srcAddressList: [], srcFqdnList: [], srcCountryList: [] }
            : this.form.srcAddress),
        },
        dstAddress: {
          ...(this.radioDstAddress === "ANY"
            ? { dstAddressList: [], dstFqdnList: [], dstCountryList: [] }
            : this.form.dstAddress),
        },
        // デフォルト、カスタムサービスリストを分解
        defaultServiceList:
          this.form.serviceOption === "SELECT"
            ? (this.form.serviceList.filter(
                (e) => "serviceSeq" in e
              ) as GetPolicy["defaultServiceList"])
            : [],
        customServiceList:
          this.form.serviceOption === "SELECT"
            ? (this.form.serviceList.filter(
                (e) => "customServiceSeq" in e
              ) as GetPolicy["customServiceList"])
            : [],
        serviceList: undefined,
        profile: {
          ...this.form.profile,
          profileInternetFw:
            this.form.profile.internetFW === "USER"
              ? this.form.profile.profileInternetFw
              : null,
        },
      } as Type1IFWPolicy & { serviceList: undefined };
      await this.$modal.show(InternetType1PolicyRuleIfwConfirm, { policy });
      (
        this.$refs.modal as typeof VueFinalModal & { ok: (e: unknown) => void }
      ).ok(policy);
    },
    /** アドレス選択肢ラベル名 */
    addressLabel({
      ipAddressName,
      ipAddress,
    }:
      | Type1InternetAddress
      | Type1ExtraInfo["siteList"][0]["addressList"][0]
      | Type1PrivateInfo["lineList"][0]["siteList"][0]["addressList"][0]): string {
      return `${ipAddressName} ${ipAddress}`;
    },
    /** FQDN選択肢ラベル名 */
    fqdnLabel({ fqdnName, fqdn }: Type1InternetFQDN): string {
      return fqdnName ?? fqdn;
    },
    /** FQDNマルチセレクトソート用func*/
    fqdnSort(
      item: GetSrcAddress1["srcFqdnList"][0] | GetDstAddress2["dstFqdnList"][0]
    ): string | null {
      return item.fqdnName ?? item.fqdn;
    },
    /** サービスラベル名（検索用） */
    serviceNameLabel({
      serviceName,
      protocol,
      portNumber,
    }: EditDefaultService | EditCustomService): string {
      return `${serviceName} ${protocol} ${portNumber}`;
    },
  },
});
</script>

<style scoped lang="scss">
:deep(.multiselect__tag) {
  display: block;
}
</style>
